export const initialState = {
  appointmentsWithPatients: [],
  loading: false
};
